import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import routes from 'consts/routes'
import Actions from 'actions'

// those pages do not have fields that could be incomplete
const SKIP_VALIDATION_PAGES = [
  routes.ENROLL_COMPARE,
  routes.ENROLL_PLAN,
  routes.ENROLL_PLANS,
  routes.ENROLL_RANK,
  routes.ENROLL_PLAN_RANK,
  routes.ENROLL_FINALIZE
]

const useApplicationValidation = ({
  validationFunction = null,
  validationParams = null,
  handleInvalid = null,
  handleValid = null
} = {}) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const isSaveRequsted = useSelector(state => state.app.isSaveRequsted)

  useEffect(() => {
    if (
      SKIP_VALIDATION_PAGES.some(path => location.pathname.startsWith(path))
    ) {
      dispatch(
        Actions.createAction(Actions.APPLICATION_VALIDATED, { isValid: true })
      )
      return
    }
    if (isSaveRequsted) {
      const errors = validationFunction(validationParams)
      const isValid = !errors
      dispatch(Actions.createAction(Actions.APPLICATION_VALIDATED, { isValid }))
      if (isValid) {
        handleValid && handleValid()
      } else {
        handleInvalid && handleInvalid()
      }
    }
  }, [
    isSaveRequsted,
    validationFunction,
    validationParams,
    handleInvalid,
    handleValid,
    dispatch
  ])

  return isSaveRequsted
}

export default useApplicationValidation
